import React from 'react';
import { ArrowRightIcon, GiftIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { useLaunchExpired } from '../../hooks/useLaunchCountdown';
import { BONOS, PRICING, PRICING_OPTIONS } from '../../data/content';
export function Pricing() {
  const isExpired = useLaunchExpired();
  const megapack = PRICING_OPTIONS[0];
  if (!megapack) return null;
  return <section className="w-full px-5 py-12 sm:py-16" aria-labelledby="pricing-title" data-id="element-184" data-mp="3pjhnb6a5a8wy">
      <div className="mx-auto max-w-xl" data-id="element-185" data-mp="3plc9enx5k72m">
        <Reveal className="text-center" data-id="element-186" data-mp="3uib0sypflzx4">
          <SectionBadge tone="dark" data-id="element-187" data-mp="3ujdpczza7q9v">
            {isExpired ? 'Acceso disponible' : 'Oferta de lanzamiento'}
          </SectionBadge>
          <h2 id="pricing-title" tabIndex={-1} className="mt-5 font-display text-2xl leading-tight text-snow outline-none sm:text-4xl" data-id="element-188" data-mp="204taj3xn6oye">
            Llevate hoy el <span className="u-lime" data-id="element-189" data-mp="25467ihi89cep">sistema completo</span>
          </h2>
        </Reveal>

        <Reveal delay={90} className="mt-8" data-id="element-190" data-mp="1bbi9j49p1uwu">
          <article className="rounded-3xl border-2 border-lime bg-rose-deep p-6 shadow-[0_22px_50px_rgba(122,30,60,0.14)] sm:p-8" data-id="element-191" data-mp="16k08kg7o7ubv">
            <header className="text-center" data-id="element-192" data-mp="11k5kekfa5iui">
              <h3 className="font-display text-3xl leading-none text-lime sm:text-4xl" data-id="element-193" data-mp="11iuf2g66s31a">
                MegaPack Árabe <span className="text-gold" data-id="element-194" data-mp="xh8x4gesoyk8">PRO</span>
              </h3>
              <p className="mt-1.5 text-sm font-bold text-snow" data-id="element-195" data-mp="1u92nhgax792o">
                {megapack.description} <span className="text-lime" data-id="element-196" data-mp="1pbt1ybqnjhk4">+ 5 bonos exclusivos gratis</span>
              </p>
            </header>

            <div className="mt-6 rounded-2xl border border-ink-line bg-ink p-4 sm:p-5" data-id="element-197" data-mp="1l7d0cmo2mwap">
              <h4 className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-snow-dim" data-id="element-198" data-mp="1g91qibxs0lsh">
                Resumen del pedido
              </h4>

              <div className="mt-3 flex items-start justify-between gap-4 border-b border-ink-line pb-3.5" data-id="element-199" data-mp="4uxtewvw6hj7">
                <div data-id="element-200" data-mp="6bbpq1n5eat0">
                  <p className="text-sm font-bold text-snow sm:text-base" data-id="element-201" data-mp="6cv23h5oo1pi">{megapack.name}</p>
                  <span className="mt-1.5 inline-flex items-center gap-1 rounded-full bg-lime/10 px-2.5 py-0.5 text-xs font-bold text-lime" data-id="element-202" data-mp="b9vavztx3ikb">
                    <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-203" data-mp="3tim23yn01epf" /> +5 bonos gratis
                  </span>
                </div>
                <span className="whitespace-nowrap text-sm font-bold text-snow sm:text-base" data-id="element-204" data-mp="3jqzsu7u81ppb">{megapack.price}</span>
              </div>

              <ul className="space-y-2.5 border-b border-ink-line py-3.5" aria-label="Bonos incluidos" data-id="element-205" data-mp="3oi84laj0xn5n">
                {BONOS.map(bono => <li key={bono.n} className="flex items-center justify-between gap-3 text-sm" data-id="element-206" data-mp="39qh3ixjw1h00">
                    <span className="min-w-0 truncate text-snow-muted" data-id="element-207" data-mp="3erwsh0p6s7no">
                      Bono #{bono.n}: {bono.title}
                    </span>
                    <span className="flex flex-shrink-0 items-center gap-2" data-id="element-208" data-mp="35rgqxws07alg">
                      <span className="whitespace-nowrap text-xs text-snow-dim line-through" data-id="element-209" data-mp="2m55abaesyx0z">{bono.price}</span>
                      <span className="rounded bg-lime px-1.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-ink" data-id="element-210" data-mp="2h6lqbfjrrvb9">
                        Gratis
                      </span>
                    </span>
                  </li>)}
              </ul>

              <div className="flex items-end justify-between gap-4 pt-3.5" data-id="element-211" data-mp="2r6clljg5mece">
                <span className="text-sm font-semibold text-snow-muted" data-id="element-212" data-mp="352q0cktb01n6">Precio total</span>
                <div className="text-right" data-id="element-213" data-mp="304522qxm3s1d">
                  {!isExpired && <p className="text-sm text-snow-dim line-through" data-id="element-214" data-mp="3etkra2hhvpey">{PRICING.totalValueOld}</p>}
                  <p className="font-display text-4xl leading-none text-snow sm:text-5xl" data-id="element-215" data-mp="39ureyddy24gd">{megapack.price}</p>
                  {!isExpired && <p className="mt-1.5 text-sm font-extrabold text-lime" data-id="element-216" data-mp="3ntr21glt6baf">Ahorrás {PRICING.savings}</p>}
                </div>
              </div>
            </div>

            <p className="mt-4 text-center text-xs font-extrabold uppercase tracking-[0.16em] text-snow" data-id="element-217" data-mp="3itl45ioy3sjw">
              {isExpired ? 'Precio actualizado · un único pago' : 'Un único pago · sin suscripciones'}
            </p>

            <CtaButton variant="lime" className="mt-5 w-full" href={megapack.checkoutUrl} data-id="element-218" data-mp="1qvjobt03wdf0">
              Quiero MegaPack Árabe PRO — {megapack.price}
              <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-219" data-mp="1uwvdjxf2iwmo" />
            </CtaButton>

            <p className="mt-3 flex items-center justify-center gap-2 text-xs font-semibold text-snow-muted" data-id="element-220" data-mp="y9h3qj3x5xxm">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-221" data-mp="138br7ycu0ao2" />
              Acceso inmediato · Pago único · Acceso de por vida
            </p>
          </article>
        </Reveal>
      </div>
    </section>;
}